
import {
    all, put, takeLatest,
} from 'redux-saga/effects';

import {
    ACCEPT_ALL_FROM_BANNER,
    acceptAllCookies,
    setCookieTimer,
    hideBanner,
} from '../reduxModules/ConsentManagementPlatform';


export function* callAction() {
    yield all([
        put(hideBanner()),
        put(setCookieTimer()),
        put(acceptAllCookies()),
    ]);
}

export function* watch() {
    yield takeLatest(ACCEPT_ALL_FROM_BANNER, callAction);
}
